export default __webpack_public_path__ + "static/media/boar.3e625249.png";